import { createAsyncThunk } from "@reduxjs/toolkit";
import { createChatCompletions } from "../../../services/api/instances/completionsApi/methods";
import type {
  ChatCompletionsRequestObject,
  TChatCompletionRequest,
} from "../../../services/api/instances/completionsApi/types";
import type { RootState } from "../../../services/redux/types";
import { getError } from "../../../services/lib/getError";
import { postMessageToCompletion } from "../../../services/api/instances/responseApi/api";

export const createChat = createAsyncThunk(
  "chatCompletion/createChat",
  async (postObject: TChatCompletionRequest, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;

      const response = await postMessageToCompletion(postObject);
      const systemMessage = {
        role: response.choices[0].message.role,
        content: response.choices[0].message.content,
      };
      const updatedMessages = [...postObject.messages, systemMessage];

      return updatedMessages;
    } catch (e: unknown) {
      const message = getError(e);
      return rejectWithValue(message ?? "An unknown error occurred");
    }
  },
);
